import React from 'react'
import styles from './styles.css'
import useIntervalUpdate from 'App/hooks/useIntervalUpdate'
import moment from 'moment'

export default function Time(props) {
  useIntervalUpdate(1000)
  const milli = moment.duration(moment().diff(props.shift.startedAt)).asMilliseconds()
  const text = moment.utc(milli).format('HH:mm:ss')

  return <div className={styles.container}>{text}</div>
}
